import { Box, Button, Typography } from '@iheartjane/reefer';
import { spacing } from '@iheartjane/reefer-emotion';
import type { HTMLProps, PropsWithChildren } from 'react';

export const SUBMIT_ERROR_TEXT = 'Please check the red errors above';

export interface ShowLoginProps {
  setShowLogin?: (arg: boolean) => void;
}

export const SubmitErrorMessage = ({ children }: PropsWithChildren) => (
  <Typography color="error" as="div" mt={8}>
    {children}
  </Typography>
);

export const CustomFieldError = ({ children }: PropsWithChildren) => (
  <Box mb={12}>{children}</Box>
);

interface ButtonProps extends HTMLProps<HTMLButtonElement> {
  'data-testid'?: string;
  label: string;
  loading?: boolean;
  type?: 'button' | 'submit';
}
export const PrimaryLoginButton = ({
  'data-testid': testId,
  disabled,
  loading,
  label,
  onClick,
}: ButtonProps) => {
  return (
    <Button
      data-testid={testId}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      // eslint-disable-next-line react/forbid-component-props -- legacy emotion
      css={{
        height: 40,
        ...spacing({ py: 0 }),
      }}
      label={label}
      type="submit"
    />
  );
};
